export type InputValue = {
  [key: string]: number;
};

/**
 * Parses a given value and an optional label into an InputValue object.
 * The InputValue object maps units to their corresponding numerical values.
 *
 * @param value The numerical or string value to parse.
 * @param label An optional label string, which can override the value if it contains semicolons.
 * @returns An InputValue object, where keys are units (or 'value' if a simple number) and values are numbers.
 */
export function ParseValueForInput(value: number | string, label?: string) {
  let valueOrLabel = value;

  if (label?.includes(';')) {
    valueOrLabel = label;
  }

  const valueObject: InputValue = {};

  if (typeof valueOrLabel === 'string') {
    valueOrLabel.split(';').forEach((unitValuePair) => {
      const unitValuePairArray = unitValuePair.split('|');

      const [formattedValue, formattedUnit] = unitValuePairArray;

      if (formattedValue !== undefined && formattedUnit !== undefined) {
        valueObject[formattedUnit as keyof InputValue] = parseInt(
          formattedValue,
          10,
        );
      }
    });
  } else {
    valueObject.value = valueOrLabel;
  }

  return valueObject;
}
